import React from "react";

import { Box, Button, Center, Container, Stack, Text, Title } from "@mantine/core";
import { IconVideo } from "@tabler/icons-react";
import { motion } from "framer-motion";

const InitPage: React.FC = () => {
  const zoomLink = "https://us06web.zoom.us/j/81488358707?pwd=PJURUv2t0WJDSA4bC9cjlvpbtCaEaV.1";

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 20, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        stiffness: 100,
      },
    },
  };

  return (
    <Box
      style={{
        width: "100%",
        height: "100vh",
        background: "#000000",
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Decorative Background Elements */}
      <motion.div
        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.3, 0.5, 0.3],
          rotate: [0, 90, 0],
        }}
        transition={{
          duration: 20,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          top: "-20%",
          left: "-10%",
          width: "60vw",
          height: "60vw",
          background: "radial-gradient(circle, rgba(66, 153, 225, 0.2) 0%, transparent 70%)",
          filter: "blur(60px)",
          zIndex: 0,
        }}
      />
      <motion.div
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.2, 0.4, 0.2],
          rotate: [0, -60, 0],
        }}
        transition={{
          duration: 25,
          repeat: Infinity,
          ease: "linear",
        }}
        style={{
          position: "absolute",
          bottom: "-20%",
          right: "-10%",
          width: "70vw",
          height: "70vw",
          background: "radial-gradient(circle, rgba(159, 122, 234, 0.2) 0%, transparent 70%)",
          filter: "blur(80px)",
          zIndex: 0,
        }}
      />

      <Container size="sm" style={{ zIndex: 1, position: "relative" }}>
        <motion.div variants={containerVariants} initial="hidden" animate="visible">
          <Center>
            <motion.div
              variants={itemVariants}
              whileHover={{ scale: 1.1, rotate: 5 }}
              style={{ marginBottom: "2rem" }}
            >
              <div
                style={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  background: "linear-gradient(135deg, #2D8CFF 0%, #000000 100%)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 10px 30px rgba(45, 140, 255, 0.3)",
                }}
              >
                <IconVideo size={40} color="white" />
              </div>
            </motion.div>
          </Center>

          <Stack align="center" gap="lg">
            <motion.div variants={itemVariants}>
              <Title
                order={1}
                style={{
                  fontSize: "3.5rem",
                  fontWeight: 900,
                  textAlign: "center",
                  background: "-webkit-linear-gradient(45deg, #fff 30%, #a5b4fc 90%)",
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  letterSpacing: "-0.02em",
                  lineHeight: 1.1,
                }}
              >
                Join the Class
              </Title>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Text
                c="dimmed"
                size="xl"
                ta="center"
                style={{ maxWidth: 500, margin: "0 auto", color: "#a0aec0" }}
              >
                Your session is ready to begin. Click the button below to connect instantly via
                Zoom.
              </Text>
            </motion.div>

            <motion.div
              variants={itemVariants}
              style={{ marginTop: "2rem" }}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <Button
                component="a"
                href={zoomLink}
                target="_blank"
                size="xl"
                radius="xl"
                h={60}
                px={50}
                style={{
                  background: "linear-gradient(135deg, #3182ce 0%, #2b6cb0 100%)",
                  boxShadow: "0 10px 25px -5px rgba(66, 153, 225, 0.4)",
                  fontSize: "1.2rem",
                  border: "none",
                }}
                leftSection={<IconVideo />}
              >
                Launch Zoom Meeting
              </Button>
            </motion.div>

            <motion.div variants={itemVariants}>
              <Text size="sm" c="dimmed" mt="xl" style={{ opacity: 0.6 }}>
                Zoom Application Required
              </Text>
            </motion.div>
          </Stack>
        </motion.div>
      </Container>
    </Box>
  );
};

export default InitPage;
